import { Inject, Injectable } from "@angular/core";
import { WINDOW } from "./window.service";
import { FEATURE_FLAGS, FeatureFlags, HOST_CONFIG, HostConfig } from "src/app/config/AppInitializer.factory";
import { UserService } from "./user.service";

@Injectable({
    providedIn: 'root'
  })
  export class BrandingService {
    constructor(
      private userService: UserService,
      @Inject(WINDOW) private window: Window,
      @Inject(HOST_CONFIG) private hostConfig: HostConfig,
      @Inject(FEATURE_FLAGS) private featureFlags: FeatureFlags) {
    }

    // TODO: Consider moving these to a configuration file with one section for EBR and another for Program Hub if more branding constants are needed.
    private readonly TITLE_BLUEPRINT = 'Blueprint';
    private readonly TITLE_PROGRAM_HUB = 'Program Hub';

    private readonly PAGE_TITLE_BLUEPRINT = 'Blueprint';
    private readonly PAGE_TITLE_PROGRAM_HUB = 'Program Hub';

    private readonly APPLICATION_NAME_BLUEPRINT = 'Blueprint';
    private readonly APPLICATION_NAME_PROGRAM_HUB = 'ProgramHub';

    private readonly UNAUTHORIZED_WARNING_MESSAGE_EBR = 'You {email}do not have access to this application.';
    private readonly UNAUTHORIZED_WARNING_MESSAGE_PROGRAM_HUB = 'You do not have access to view this application, please reach out to your Ecolab Corporate Account Manager to request access.';

    private readonly TECHNICAL_ISSUE_MESSAGE_BLUEPRINT = 'Blueprint is currently experiencing technical difficulties, check back soon for additional details';
    private readonly TECHNICAL_ISSUE_MESSAGE_PROGRAM_HUB = 'We regret to inform you that Program Hub is currently experiencing technical difficulties. Our team is actively working to resolve the issue as quickly as possible. We understand the inconvenience this may cause and appreciate your patience and understanding during this time.';
    private static readonly MULTIPLE_HIERARCHIES_SELECTED_MESSAGE = 'Not Applicable. Please select one H5 only, one H5 and one H7 or individual accounts fom the same H5/H7';

    get isProgramHub() {
        return this.window.location.host.endsWith(this.hostConfig.programHubUrlHost);
    }

    get title() {
      if (this.isProgramHub) {
        return this.TITLE_PROGRAM_HUB;
      }

      return this.TITLE_BLUEPRINT;

    }

    get pageTitle() {
      if (this.isProgramHub) {
        return this.PAGE_TITLE_PROGRAM_HUB;
      }

      return this.PAGE_TITLE_BLUEPRINT;

    }

    get applicationName() {
      if (this.isProgramHub) {
        return this.APPLICATION_NAME_PROGRAM_HUB;
      }

      return this.APPLICATION_NAME_BLUEPRINT;

    }

    get unauthorizedWarningMessage () {
      if (this.isProgramHub) {
        return this.UNAUTHORIZED_WARNING_MESSAGE_PROGRAM_HUB;
      }

      const email = this.userService.getUsername();
      if(email == null || email == undefined || email == '') {
        return this.UNAUTHORIZED_WARNING_MESSAGE_EBR.replace('{email}', '');
      }else{
        return this.UNAUTHORIZED_WARNING_MESSAGE_EBR.replace('{email}', `(${email}) `);
      }
    }

    get technicalIssuesMessage() {
      if (this.isProgramHub) {
        return this.TECHNICAL_ISSUE_MESSAGE_PROGRAM_HUB;
      }

      return this.TECHNICAL_ISSUE_MESSAGE_BLUEPRINT;

    }

    static get multipleHierarchiesSelectedMessage() {
      return this.MULTIPLE_HIERARCHIES_SELECTED_MESSAGE;
    }
  }
